<template>
  <!-- 主要内容 -->
  <div class="content-main">
    <!-- <div class="box-title">
      <p>名称</p>
      <p>日期</p>
      <p>操作</p>
    </div> -->
    <div v-if="mydata.userDownloadArr.length === 0">
      <p
        style="
          line-height: 300px;
          text-align: center;
          letter-spacing: 1px;
          color: #999999;
        "
      >
        暂无下载
      </p>
    </div>
    <div class="box-big" v-else>
      <div
        class="box-item"
        v-for="(item, index) in mydata.userDownloadArr"
        :key="index"
      >
        <p style="cursor: pointer" @click="titleClick(item)">
          <!-- <el-icon><DocumentRemove /></el-icon> -->
          <span>{{ item.myTitle }}</span>
        </p>
        <div>
          <span> 日期：{{ item.create_time.slice(0, 10) }}</span>
          <p>
            <icon-park
              type="downloadFour"
              theme="filled"
              style="cursor: pointer"
              @click="downloadButton(item)"
            />
            <!-- {{ item.is_downloads }} -->
            <el-icon @click="delDownloadButton(item)" style="cursor: pointer"
              ><Delete
            /></el-icon>
          </p>
        </div>
      </div>
    </div>
    <!--分页 -->
    <div class="gl-pagination">
      <el-pagination
        v-model:currentPage="mydata.pageObj.currentPage"
        v-model:page-size="mydata.pageObj.pageSize"
        :total="mydata.pageObj.total"
        layout="prev, pager, next"
        pager-count="4"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script setup>
import { DocumentRemove, Delete } from "@element-plus/icons-vue";

import { IconPark } from "@icon-park/vue-next/es/all";

import { reactive, watch, ref } from "vue";

import { useRouter, useRoute } from "vue-router";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import dayjs from "dayjs";

// 引入我的下载列表
import {
  userDownloadList,
  userDownloadUrl,
} from "@/api/personalCenter/myDownloads/index.js";

// 引入删除下载接口
import { delDownloadList } from "@/api/personalCenter/myDownloads/index.js";

import { getBlobByUrl } from "@/api/boutiqueTaobaoQuestions/topicSubjectDetails/index.js";
const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  currentPage3: "5",
  pageSize3: "100",
  small: false,
  background: false,
  disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],

  /////
  pageObj: {
    currentPage: 1, // 当前页数
    pageSize: 10, // 每页条数
    total: 0, // 总的条数
  },
  userDownloadArr: [], //我的下载列表
  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {},
  progressValue: "",
  loadingShow: false,
});

const props = defineProps({
  type: {
    type: String,
    // default:""
  },
});

watch(
  () => {
    return props.type;
  },
  (nv, ov) => {
    // console.log('nv',nv);
    // 重置数据
    mydata.pageObj = {
      currentPage: 1, // 当前页数
      pageSize: 10, // 每页条数
      total: 0, // 总的条数
    };
    mydata.userDownloadArr = [];
    // 请求数据
    userDownloadFn();
  }
);

// 当前页数改变事件
function handleCurrentChange(val) {
  // 请求数据
  userDownloadFn();
}

//删除下载
function delDownloadButton(item) {
  ElMessageBox.confirm("是否删除该条数据？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      // 调用接口
      delDownloadList(mydata.userInfo.jwt, { id: item.id }).then((res) => {
        ElMessage({
          message: res.msg,
          type: "success",
        });
        // 查询列表
        userDownloadFn();
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "已取消操作",
      });
    });
}

//获取我的下载列表
function userDownloadFn() {
  userDownloadList(
    mydata.userInfo.jwt,
    {
      type: props.type,
      page: String(mydata.pageObj.currentPage),
      psize: String(mydata.pageObj.pageSize),
    }
    // // formDataObj
    // {
    // type: mydata.type,
    // // page: String(mydata.pageObj.currentPage),
    // // psize: String(mydata.pageObj.pageSize),
    // }
  ).then((res) => {
    // console.log(res.data.list,"试卷-图书")
    mydata.userDownloadArr = res.data.list.map((item) => {
      if (props.type === "1") {
        item.myTitle = item.exam_title;
      } else if (props.type === "2") {
        item.myTitle = item.book_title;
      }
      return item;
    });
    // console.log(res.data.list,"我的下载")
    // mydata.ulLi.push({
    //   id: 0,
    //   user_id: 0,
    //   content_id: 0,
    //   create_time: "2020-02-02 14:15:16",
    //   name: "名字",
    // });
    // 总的条数
    mydata.pageObj.total = res.data.count;
  });
}
userDownloadFn();

const loading = ref();

// 进度函数
function progressFn(resultNumber) {
  // 如果不可出现loading加载了，那么就直接终止代码
  if (!mydata.loadingShow) {
    return;
  }
  // console.log(112);

  // 赋值
  mydata.progressValue = resultNumber;
  // 需要注意的是，以服务的方式调用的全屏 Loading 是单例的。
  loading.value = ElLoading.service({
    lock: true,
    text: mydata.progressValue + "%",
    background: "rgba(255, 255, 255, 0.8)",
  });
  // 设置文本内容（它会执行多次）
  loading.value.setText(mydata.progressValue + "%");
  // 如果进度是100了，那就关闭loading加载（它可能不准确）
  if (mydata.progressValue === 100) {
    loading.value.close();
  }
}

//增值下载
async function downloadButton(item) {
  let res = await userDownloadUrl({
    id: item.id,
  });
  let arr1 = res.data.url.split(",");
  // 下载文件 start ///////////////////////////////////////
  for (const item of arr1) {
    let ele = document.createElement("a");
    ele.href = item;
    ele.click();
  }
  // 下载文件 end ///////////////////////////////////////
  // console.log(arr1);
  // arr1.forEach(async (item) => {
  //   let arr = item.split("/");
  //   let name = arr[arr.length - 1];
  //   // // 可以出现loading加载了
  //   // mydata.loadingShow = true;
  //   // let res2 = await getBlobByUrl(item, progressFn);
  //   // // 不可出现loading加载了
  //   // mydata.loadingShow = false;
  //   // // 关闭loading加载
  //   // loading.value.close();
  //   // // 清空loading文本
  //   // mydata.progressValue = "";

  //   // let url = URL.createObjectURL(res2);
  //   let ele = document.createElement("a");
  //   ele.href = item;
  //   ele.target = "_blank";
  //   ele.download = name;
  //   ele.click();
  // });
}

function titleClick(info) {
  // 试卷
  if (info.type === "1") {
    router.push({
      path: "/layout/list/topicSubjectDetails",
      query: { id: info.content_id },
    });
  }

  // 图书
  if (info.type === "2") {
    router.push({
      path: "/layout/list/booksDetails",
      query: { id: info.content_id },
    });
  }
}
</script>

<style scoped lang="scss">
//主要内容
.content-main {
  // width: 916px;
  //height: 567px;
  // margin: 0 auto !important;
  // border: 1px solid red;
  // margin-top: 30px;
  // .box-title {
  //   width: 916px;
  //   height: 47px;
  //   padding: 0px 43px 0px 19px;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   font-size: 16px;
  //   font-weight: 400;
  //   color: #333333;
  //   background-color: #f7f9fa;
  //   //  border:1px solid blue;
  //   > p:first-of-type {
  //     width: 345px;
  //     // border:1px solid red;
  //   }
  //   > p:nth-of-type(2) {
  //     width: 168px;
  //     // border:1px solid red;
  //   }
  //   > p:nth-of-type(3) {
  //     width: 80px;
  //     // border:1px solid red;
  //   }
  // }
  //装每一条的大盒子
  .box-big {
    min-height: 500px;
    // height: 520px;
    // border:1px solid blue;
    //每一条
    .box-item {
      height: 100px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // align-items: center;
      // padding: 0px 43px 0px 19px;
      // margin-bottom: 20px;
      // position: relative;
      border-bottom: 1px solid #dcdee2;
      font-size: 16px;
      padding: 16px 0px 10px 0px;
      font-weight: 400;
      color: #333333;
      > p {
        width: 345px;
        // border:1px solid rgb(0, 255, 85);
        line-height: 22px;

        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 2; //几行
        overflow: hidden;

        display: flex;
        // align-items: center;
        //图标
        :deep(.el-icon) {
          // color:red;
          height: 22px;
          font-size: 18px;
          // font-weight:700;
          margin-right: 8px;
        }
        // >span{

        // }
      }
      > div {
        // width: 168px;
        font-size: 14px;
        color: #666666;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // border:1px solid red;
        // > span {
        //   margin-right: 20px;
        // }

        > p {
          display: flex;
          // justify-content: space-between;
          align-items: center;
          //下载图标
          :deep(.i-icon.i-icon-download-four) {
            font-size: 18px;
            color: #009de0;
            margin-right: 10px;
          }
          :deep(.el-icon) {
            font-size: 18px;
            color: #666666;
            margin-left: 20px;
            // margin-top: 2px;
          }
        }
      }
    }
    .box-item:nth-last-of-type(1) {
      margin-bottom: 0px;
    }

    .box-item:hover {
      p {
        color: #009de0;
      }
    }
  }

  //////////分页
  .paging {
    // margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 40px;
    :deep(.el-button.is-plain) {
      margin-left: 24px;
    }
  }
  //最左边的箭头
  :deep(.btn-prev.is-first) {
    margin-right: 12px;
    background-color: #f5f6f7;
  }
  :deep(.btn-next) {
    background-color: #f5f6f7;
  }
  //每个页
  :deep(.number) {
    margin-right: 12px;
    // color:#BBBDBF;
    background-color: #f5f6f7;
  }
  //省略号
  :deep(.more.btn-quicknext.el-icon) {
    margin-right: 12px;
    background-color: #f9f9f9;
  }

  .demo-pagination-block + .demo-pagination-block {
    margin-top: 10px;
  }
  .demo-pagination-block .demonstration {
    margin-bottom: 16px;
  }
}
// .content-main {
//   width: 916px;
//   //height: 567px;
//   // border:1px solid red;
//   // margin-top: 30px;
//   .box-title {
//     width: 916px;
//     height: 47px;
//     padding: 0px 43px 0px 19px;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     font-size: 16px;
//     font-weight: 400;
//     color: #333333;
//     background-color: #f7f9fa;
//     //  border:1px solid blue;
//     > p:nth-of-type(2) {
//       width: 64px;
//       // border: 1px solid red;
//     }
//   }
//   .box-item {
//     height: 65px;
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 0px 43px 0px 19px;
//     // margin-bottom: 20px;
//     // position: relative;
//     border-bottom: 1px solid #dcdee2;
//     font-size: 16px;
//     font-weight: 400;
//     color: #333333;
//     > p:nth-of-type(1) {
//       width: 345px;
//       // border:1px solid rgb(0, 255, 85);
//       line-height: 24px;
//       display: -webkit-box;
//       -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
//       text-overflow: ellipsis; //文本溢出 用省略号显示
//       -webkit-line-clamp: 2; //几行
//       overflow: hidden;
//     }
//     > p:nth-of-type(2) {
//       width: 64px;
//     }
//   }
//   .box-item:nth-last-of-type(1) {
//     margin-bottom: 0px;
//   }
//   // .box-item::before {
//   //   content: "";
//   //   position: absolute;
//   //   display: block;
//   //   top: 9px;
//   //   left: 0px;
//   //   width: 7px;
//   //   height: 7px;
//   //   background-color: #dcdee2;
//   //   border-radius: 3.5px;
//   // }

//   .box-item:hover {
//     p {
//       color: #009de0;
//     }
//   }
//   // .box-item:hover::before {
//   //   content: "";
//   //   position: absolute;
//   //   display: block;
//   //   top: 9px;
//   //   left: 0px;
//   //   width: 7px;
//   //   height: 7px;
//   //   border-radius: 3.5px;
//   //   background-color: #009de0 !important;
//   // }

//   //////////分页
//   .paging {
//     // margin: 0 auto;
//     display: flex;
//     justify-content: center;
//     margin-top: 40px;
//     margin-bottom: 40px;
//     :deep(.el-button.is-plain) {
//       margin-left: 24px;
//     }
//   }
//   //最左边的箭头
//   :deep(.btn-prev.is-first) {
//     margin-right: 12px;
//     background-color: #f5f6f7;
//   }
//   :deep(.btn-next) {
//     background-color: #f5f6f7;
//   }
//   //每个页
//   :deep(.number) {
//     margin-right: 12px;
//     // color:#BBBDBF;
//     background-color: #f5f6f7;
//   }
//   //省略号
//   :deep(.more.btn-quicknext.el-icon) {
//     margin-right: 12px;
//     background-color: #f9f9f9;
//   }

//   .demo-pagination-block + .demo-pagination-block {
//     margin-top: 10px;
//   }
//   .demo-pagination-block .demonstration {
//     margin-bottom: 16px;
//   }
// }
</style>